export default __webpack_public_path__ + "static/media/content.79577c43.svg";